module.exports = __webpack_public_path__ + "img/hideicon.e630d369.svg";